import { createSlice } from '@reduxjs/toolkit'

export const contactFloatingSlice = createSlice({
    name: 'contactFloating',
    initialState: {
        unfolded: false,
    },
    reducers: {
        unfold: state => {
            state.unfolded = true
        },
        fold: state => {
            state.unfolded = false
        },
        toggle: state => {
            state.unfolded = !state.unfolded
        },
    },
})

export const { unfold, fold, toggle } = contactFloatingSlice.actions
export default contactFloatingSlice.reducer
